import React, { Component } from 'react'
import { Link } from 'react-router'
import i18next from 'i18next'
import { Row, Col } from 'react-bootstrap'
import classnames from 'classnames'
import { List } from 'immutable'

import GridContainer from './GridContainer'
import Loading from './Loading'
import Paginator from './Paginator'
import UnitDetailsWopi360TargetNoResults from './UnitDetailsWopi360TargetNoResults'
import UnitDetailsWopi360AddModal from './UnitDetailsWopi360AddModal'
import Wopi360TargetListTable from './Wopi360TargetListTable'
import Button from './Button'

import listingStyles from './styles/listing.scss'
import buttonStyles from './styles/button.scss'
import unitStyles from './styles/unit.scss'

export default class UnitDetails extends Component {
  constructor(props) {
    super(props)

    this.state = {
      language: this.props.currentLanguage,
      isWopi360TargetAddModalVisible: false,
      isUpdatingRelations: false
    }
  }

  componentDidMount() {
    this.props.getUnit(this.props.params.uuid)
    this.getWopi360Targets()
  }

  getWopi360Targets = (page = 1) => {
    this.props.getUnitWopi360Targets({
      organisationId: this.props.currentOrganisationId,
      unitUuid: this.props.params.uuid,
      filters: { status: 'all' },
      page
    })
  }

  handlePagination = page => {
    this.getWopi360Targets(page)
  }

  handleRemoveWopi360Target = targetUuid => {
    if (confirm(i18next.t('are_you_sure'))) {
      this.props.removeWopi360TargetFromUnit(this.props.params.uuid, targetUuid)
    }
  }

  handleLanguageChange = language => {
    this.setState({ language })
  }

  handleToggleWopi360AddModal = () => {
    this.setState(state => ({
      isWopi360TargetAddModalVisible: !state.isWopi360TargetAddModalVisible
    }))
  }

  handleWopi360AddModalSubmit = targetUuids => {
    this.setState({ isUpdatingRelations: true })

    const targetUuidsWithExisting = [...this.props.wopi360Targets.map(t => t.uuid), ...targetUuids]

    this.props
      .updateUnitWopi360TargetRelations(this.props.unit.uuid, targetUuidsWithExisting)
      .then(() => {
        this.setState({ isUpdatingRelations: false, isWopi360TargetAddModalVisible: false })
        this.getWopi360Targets()
      })
  }

  render() {
    const { language, isWopi360TargetAddModalVisible, isUpdatingRelations } = this.state
    const { unit, isLoading, wopi360Targets, wopi360TargetsPagination } = this.props

    if (isLoading || !unit) {
      return <Loading inline />
    }

    return (
      <GridContainer>
        <div style={{ marginBottom: 365 }}>
          <header>
            <Row>
              <Col sm={6}>
                <h1 style={{ marginRight: 20 }}>{unit.name}</h1>

                <Link to={`/units/edit/${unit.uuid}`}>{i18next.t('unit_edit')}</Link>
              </Col>

              <Col sm={6}>
                <a
                  href={`/api/units/${unit.uuid}/targets/profiles/${language}`}
                  className={classnames([buttonStyles.button, unitStyles.pushRight])}
                >
                  {i18next.t('unit_download_wopi360_results_and_average')}
                </a>
              </Col>
            </Row>
          </header>

          <Row>
            <Col md={6}>
              <span className={listingStyles.description}>{unit.description}</span>
            </Col>
          </Row>

          <h3>
            <Row>
              <Col sm={6}>{i18next.t('wopi360')}</Col>

              <Col sm={6}>
                <div className={unitStyles.pushRight}>
                  <Button
                    onClick={this.handleToggleWopi360AddModal}
                    text={i18next.t('unit_attach_360_targets')}
                  />
                </div>
              </Col>
            </Row>
          </h3>

          {wopi360Targets && (
            <div style={{ marginTop: '15px' }}>
              {wopi360Targets.isEmpty() && <UnitDetailsWopi360TargetNoResults />}

              {!wopi360Targets.isEmpty() && (
                <Wopi360TargetListTable
                  targets={wopi360Targets}
                  deletedTargets={List()}
                  latestClosedWopi360TargetUuid={null}
                  language={language}
                  deleteText={i18next.t('unit_remove_360_target')}
                  onDeleteRow={this.handleRemoveWopi360Target}
                  onChangeLanguage={this.handleLanguageChange}
                  hideUnits
                  hasLanguageSelector
                />
              )}

              {wopi360TargetsPagination && (
                <Paginator
                  totalCount={wopi360TargetsPagination.totalCount}
                  page={wopi360TargetsPagination.page}
                  limit={wopi360TargetsPagination.limit}
                  onPaginate={this.handlePagination}
                />
              )}
            </div>
          )}
        </div>

        <UnitDetailsWopi360AddModal
          isVisible={isWopi360TargetAddModalVisible}
          isUpdatingRelations={isUpdatingRelations}
          organisationId={this.props.currentOrganisationId}
          unitTargets={wopi360Targets ? wopi360Targets : List()}
          handleClose={this.handleToggleWopi360AddModal}
          onSubmit={this.handleWopi360AddModalSubmit}
        />
      </GridContainer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/UnitDetails.js